import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiLock, FiAlertCircle, FiArrowRight } = FiIcons;

function AdminPage({ onLogin }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    
    // Ruft die Funktion aus App.jsx auf
    if (onLogin(password)) {
      navigate('/dashboard');
    } else {
      setError('Zugriff verweigert. Falsches Passwort.');
    }
  };

  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-gradient-to-br from-black via-gray-900 to-black"></div>
      
      <motion.div 
        className="relative z-10 w-full max-w-sm bg-white/5 backdrop-blur-xl rounded-2xl p-8 border border-white/10"
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.4 }}
      >
        <div className="text-center mb-8">
          <div className="w-14 h-14 bg-gradient-to-br from-orange-500 to-red-600 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg shadow-orange-500/20">
            <SafeIcon icon={FiLock} className="text-white text-xl" />
          </div>
          <h1 className="text-xl font-black text-white uppercase tracking-tight">Admin Access</h1>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          {error && (
            <motion.div 
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              className="bg-red-500/10 border border-red-500/20 rounded-lg p-3 flex items-center gap-2 text-red-200 text-xs font-medium"
            >
              <SafeIcon icon={FiAlertCircle} className="text-sm flex-shrink-0" />
              {error}
            </motion.div>
          )}

          <div>
            <div className="relative">
              <input 
                type="password" 
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-black/50 border border-white/10 rounded-lg py-3 px-4 pl-10 text-white text-center placeholder-white/20 focus:outline-none focus:border-orange-500 transition-all font-mono tracking-widest"
                placeholder="Passwort eingeben"
                autoFocus
              />
              <div className="absolute left-3 top-3.5 text-white/30">
                <SafeIcon icon={FiLock} className="text-sm" />
              </div>
            </div>
          </div>

          <button 
            type="submit"
            className="w-full bg-white text-black py-3 rounded-lg font-bold uppercase tracking-wider hover:bg-orange-400 transition-colors flex items-center justify-center gap-2 group"
          >
            <span>Login</span>
            <SafeIcon icon={FiArrowRight} className="group-hover:translate-x-1 transition-transform" />
          </button>
        </form>

        <div className="mt-6 text-center">
          <a href="/" className="text-white/30 hover:text-white text-xs font-medium transition-colors">
            Abbrechen
          </a>
        </div>
      </motion.div>
    </div>
  );
}

export default AdminPage;